import React, { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Paragraph } from 'common/components';
import { SuccessWrapper } from 'modules/account/features/singup/components/index.styled';

import { useMutationActivateRenter } from '../hooks';

export const ConfirmActivationRenter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { mutate } = useMutationActivateRenter();
  const { fontFamily } = useTheme();

  useEffect(() => {
    const id = searchParams.get('id');
    if (id) {
      mutate(id, {
        onSuccess: () => navigate('/login'),
      });
    }
  }, [mutate, navigate, searchParams]);

  return (
    <SuccessWrapper>
      <Paragraph fontFamily={fontFamily.regular} fontSize="1rem" fontWeight="400" margin="0">
        {t('Redirecting to the login page in a few seconds...')}
      </Paragraph>
    </SuccessWrapper>
  );
};
